export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/vogue_df.png?3ab50f3fabfe3af475a8a12d763c5076";